/**
 * Icono del aplicativo Logística (familia Trazabis DS): hoja de albarán con
 * sus lineas y el distintivo lila con un camion. Generado con
 * `scripts/appicon.py --name Logistica --sheet lines --badge truck` de la skill
 * `aplicativos-visual`; los SVG sueltos estan en `public/logistica-icono*.svg`.
 *
 * `variante="principal"` (fondo Azul Trazabis) se usa en oscuro; `"claro"`
 * (fondo lavanda) en claro. Son colores del icono oficial, no del tema: por eso
 * van en hex y no en tokens.
 */
export function LogisticaIcono({
  variante = 'principal',
  size = 36,
  className,
}: {
  variante?: 'principal' | 'claro'
  size?: number
  className?: string
}) {
  const claro = variante === 'claro'
  const fondo = claro ? '#F1E8FF' : '#14376B'
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <rect width="512" height="512" rx="112" fill={fondo} />
      <rect
        x="112"
        y="96"
        width="248"
        height="296"
        rx="26"
        fill="#FFFFFF"
        {...(claro ? { stroke: '#D9DEE8', strokeWidth: 6 } : {})}
      />
      <rect x="146" y="132" width="104" height="22" rx="11" fill="#14376B" />
      <rect x="146" y="190" width="120" height="16" rx="8" fill="#9DBBF5" />
      <rect x="286" y="190" width="40" height="16" rx="8" fill="#D9DEE8" />
      <rect x="146" y="230" width="96" height="16" rx="8" fill="#9DBBF5" />
      <rect x="286" y="230" width="40" height="16" rx="8" fill="#D9DEE8" />
      <rect x="146" y="270" width="108" height="16" rx="8" fill="#CCABFE" />
      <rect x="146" y="320" width="70" height="16" rx="8" fill="#D9DEE8" />
      <circle cx="366" cy="366" r="92" fill={fondo} />
      <circle cx="366" cy="366" r="76" fill="#8127E3" />
      <g
        transform="translate(366 366) scale(3.2) translate(-12 -12)"
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" />
        <path d="M15 18H9" />
        <path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14" />
        <circle cx="17" cy="18" r="2" />
        <circle cx="7" cy="18" r="2" />
      </g>
    </svg>
  )
}

/** Las dos variantes juntas: el CSS de Trazabis DS muestra la del tema activo. */
export function LogisticaIconoTema({ size = 36 }: { size?: number }) {
  return (
    <>
      <LogisticaIcono variante="claro" size={size} className="tz-ic-light" />
      <LogisticaIcono variante="principal" size={size} className="tz-ic-dark" />
    </>
  )
}
